import { ADICIONAR_FILTRO_EMPRESA, LISTAR_FILTROS_EMPRESAS, REMOVER_FILTRO_EMPRESA } from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosEmpresas = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_EMPRESA: {      
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_EMPRESA: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    default:
      return state
  }
}

export const filtrosEmpresas = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_EMPRESAS: {
      return action.payload.data
    }
    default:
      return state
  }
}
